import { render, staticRenderFns } from "./Nebbia.vue?vue&type=template&id=0eddfaf0&"
import script from "./Nebbia.vue?vue&type=script&lang=js&"
export * from "./Nebbia.vue?vue&type=script&lang=js&"
import style0 from "./Nebbia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports